import CONSTANT from '../../constants'
import fetchWithAuthorizationHeader from '../../helper/fetchWithAuthorizationHeader'
import type { ApiRejectionRequest } from '../../types/apis'

const { APIS_API_URL } = CONSTANT

const rejectApi = async (apiRejection: ApiRejectionRequest): Promise<any> => {
	const response = await fetchWithAuthorizationHeader(`${APIS_API_URL}`, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			action: 'REJECT'
		},
		body: JSON.stringify(apiRejection)
	})

	return response.json()
}

export default rejectApi
